import { Injectable } from '@angular/core';
import {
    NoticeAudience,
    PersonsOrganisationDto
} from '@flyfreely-portal-ui/flyfreely';
import { MODAL_OPTIONS } from '@flyfreely-portal-ui/ngx-bootstrap-customisation';
import { BsModalService } from 'ngx-bootstrap/modal';
import { LotamDetailsDialogueComponent } from './lotam-details-dialogue/lotam-details-dialogue.component';

@Injectable({
    providedIn: 'root'
})
export class LotamDialoguesService {
    constructor(private modelService: BsModalService) {}

    showAddLotamDialogue(
        organisation: PersonsOrganisationDto,
        audience: NoticeAudience
    ) {
        return this.modelService.show(LotamDetailsDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-lg',
            initialState: {
                organisationId: organisation.id,
                isNew: audience
            }
        });
    }

    showCloneLotamDialogue(
        organisation: PersonsOrganisationDto,
        cloneSourceId?: number
    ) {
        return this.modelService.show(LotamDetailsDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-lg',
            initialState: {
                organisationId: organisation.id,
                isNew: cloneSourceId
            }
        });
    }

    showLotamDetailDialogue(lotamId: number, organisationId: number) {
        return this.modelService.show(LotamDetailsDialogueComponent, {
            ...MODAL_OPTIONS,
            class: 'modal-lg',
            initialState: {
                organisationId,
                lotamId
            }
        });
    }
}
